import {ScopeModel} from './types'
import {createContext} from 'react'

export type PromiseModalContent = {
    promiseModalStack: ScopeModel,
    setPromiseModalStack:(scope: ScopeModel) => void
}

export const PromiseModalContext = createContext<PromiseModalContent >({
    promiseModalStack: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setPromiseModalStack: () => {},
})
